import { render } from "./course-resume.vue?vue&type=template&id=6e0b0935&scoped=true"
import script from "./course-resume.vue?vue&type=script&lang=js"
export * from "./course-resume.vue?vue&type=script&lang=js"

import "./course-resume.vue?vue&type=style&index=0&id=6e0b0935&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0b0935"]])

export default __exports__